/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// material
import {
    Card,
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    Paper,
    TableHead,
    Box,
    Modal,
    useTheme,
    IconButton,
    CircularProgress,
    Skeleton,
    Menu,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// components
import { collection, doc, getDoc, getDocs, query } from 'firebase/firestore';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Page from '../../../../components/Page';
import Scrollbar from '../../../../components/Scrollbar';
import Iconify from '../../../../components/Iconify';

// mock

import { db } from '../../../../firebase.config';
import CheckCard from '../../../../components/CheckCard';
import { UserAuth } from '../../../../context/AuthContext';
import PdfRedditionDef from '../../../../components/pdf/comptabilite/redditionDef';
import CustomTag from '../../../../components/customTag';

// ----------------------------------------------------------------------


const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 2,
    width: 400,
    bgcolor: 'white',
    border: '1px solid white',
    borderRadius: '7px',
    boxShadow: 0,
    '@media (max-width: 600px)': {
        width: '90%', // Redimensionne sur mobile
    },
};
// ----------------------------------------------------------------------




export default function Comptabilte() {
    const { user } = UserAuth();
    const [orgID, setOrgID] = React.useState();

    // loading
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = useState({
        name: '',
        devise: '',
        editionDate: '',
        invoiceNumber: '',
        description: '',
        event: { seance: 0, name: '', date: '', location: '' },
        organizer: { type: 0, denomination: '', name: '', email: '', phone: '' },
        participants: [],
        revenue: [],
    });



    // take operateurs from firebase
    const [versements, setVersements] = React.useState([]);

    React.useEffect(() => {
        (async () => {
            setVersements([]);
            try {
                setLoading(true);

                const docRef0 = doc(db, 'organisateurs', `${user.uid}`);

                const docSnap = await getDoc(docRef0);
                /* if (docSnap.exists()) {
                  
                } */
                const q = query(collection(db, `organisations/${docSnap.data().idOrg}/accounting`));
                const snapshot = await getDocs(q);
                const results = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const d of snapshot.docs) {
                    // eslint-disable-next-line no-await-in-loop
                    const docSnap1 = await getDoc(doc(db, 'evenement', d.id));
                    if (docSnap1.exists()) {
                        results.push(docSnap1);
                    }
                }
                setVersements(results);
                setOrgID(docSnap.data().idOrg)
                setLoading(false);
            } catch (error) {
                console.log('error');
            }
        })();
    }, [user]);


    const handleTimestamp = (e) => (e?.toDate ? e.toDate() : new Date(e));



    // Modal download Ticket
    const [openTicketModal, setOpenTicketModal] = React.useState(false);
    const handleOpenTicketModal = () => setOpenTicketModal(true);
    const handleCloseTicketModal = () => setOpenTicketModal(false);

    // telecharger re
    const downloadSelectedTicket = async (index) => {
        setLoading(true);
        try {
            const event = versements[index]
            console.log(event.data());

            // event
            // organisations
            const orgSnap = await getDoc(doc(db, `organisations`, `${event.data().orgId}`));
            const contact = await getDoc(doc(db, `organisations/${event.data().orgId}/coordonnee`, `${event.data().orgId}`));
            const representant = await getDoc(doc(db, `organisations`, `${event.data().orgId}`));
            console.log(contact.data());
            // repartition de participant par billet
            const participants = [];
            const seances = [];
            const billetSnapshot = await getDocs(collection(db, `evenement/${event.id}/tickets`));
            billetSnapshot.forEach((doc) => {
                const billet = doc.data();
                console.log(billet)
                participants.push({ ticketType: `${billet.ticket_name}`, quantity: billet.sell })
            });
            if (event.data().seanceActive === 1) {
                const seanceSnapshot = await getDocs(collection(db, `evenement/${event.id}/seances`));
                seanceSnapshot.forEach((doc) => {
                    const seance = doc.data();
                    console.log(seance)
                    seances.push({ totalParticipants: `${seance.participants}`, recette: seance.recette })
                });
            }
            // recette
            const recetteSnapshot = await getDoc(doc(db, `evenement/${event.id}/recette`, event.id));
            setData({
                name: `${event.data().nomEvent} Reedition des comptes.pdf`,
                edditionDate: `${format(Date.now(), 'dd/MM/yyyy', { locale: fr })}`,
                devise: 'CFA',
                editionDate: "16 Novembre 2024",
                invoiceNumber: Date.now(),
                description:
                    `Reddition des comptes en CFA valant facture émise au nom ${orgSnap.data().nomOrg} et pour le compte de par Choptonticket, conformément au contrat de commissionnaire opaque en billetterie`,
                event: {
                    seance: event.data().seanceActive,
                    name: `${event.data().name ? event.data().name : event.data().nomEvent}`,
                    date: `du ${format(new Date(handleTimestamp(event.data().dateDebut)), 'EEE dd, MMMM yyyy', { locale: fr })} au ${format(new Date(handleTimestamp(event.data().dateFin)), 'EEE dd, MMMM yyyy', { locale: fr })}`,
                    location: `${event.data().localisationDes ? event.data().localisationDes : event.data().lieu_event}`,
                },
                organizer: {
                    type: 0,
                    denomination: `${orgSnap.data().nomOrg}`,
                    name: "John Doe",
                    city: `${contact.data().city}`,
                    country: `${contact.data().country}`,
                    email: `${orgSnap.data().nomOrg}`,
                    phone: `${contact.data().tel}`,
                },
                participants,
                revenue: [
                    { item: "Billets vendus", amount: recetteSnapshot.data().recette },
                    { item: "Remboursements", amount: -recetteSnapshot.data().recette },
                    { item: "code promo", amount: -recetteSnapshot.data().codePromo },
                    { item: "Commissions d'affiliation", amount: -recetteSnapshot.data().recette },
                    { item: "Frais choptonticket", amount: -recetteSnapshot.data().frais },
                    { item: "Revenu net", amount: 8800 },
                    { item: "Revenu verse", amount: recetteSnapshot.data().verse ? recetteSnapshot.data().verse : 0 },
                ],
                seances,
            })
            handleOpenTicketModal();
            setTimeout(() => {
                downloadLinkRef.current.click();
                handleCloseTicketModal();
            }, 5000);
            setLoading(false);
            //

        } catch (error) {
            console.log(error);
        }


        // handleCloseDownloadModal();
    };

    const downloadLinkRef = useRef(null);


    return (
        <Page title="Comptabilité">
            <Container sx={{ marginTop: { xs: 3 } }}>
                <CheckCard />
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Comptabilité
                    </Typography>
                </Stack>

                <Modal
                    open={openTicketModal}
                    onClose={handleCloseTicketModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ borderRadius: '7px' }}
                >
                    <Box sx={styleModal}>
                        <CircularProgress />
                        <PDFDownloadLink
                            document={<PdfRedditionDef data={data} />}
                            fileName={`${data.name}`}
                        >
                            {({ loading }) => (
                                // eslint-disable-next-line react/button-has-type
                                <button ref={downloadLinkRef} style={{ display: 'none' }}>
                                    {loading ? 'Chargement du document...' : 'Télécharger'}
                                </button>
                            )}
                        </PDFDownloadLink>
                    </Box>
                </Modal>

                <Card sx={{ boxShadow: 0 }}>
                    <Scrollbar>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 500 }} aria-label="caption table">
                                <TableHead sx={{ bgcolor: '#f2f2f2' }}>
                                    <TableRow>
                                        <TableCell>Evenement</TableCell>
                                        <TableCell>Date de début</TableCell>
                                        <TableCell>Date de Fin</TableCell>
                                        <TableCell>Reddition</TableCell>

                                    </TableRow>
                                </TableHead>
                                {loading ? (
                                    <caption>
                                        <Skeleton variant="rounded" width="100%" />
                                    </caption>
                                ) : versements.length === 0 && !loading ? (
                                    <caption>
                                        <Stack spacing={1} sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                            <Iconify icon="icomoon-free:drawer2" sx={{ width: 30, height: 30 }} />
                                            <Typography variant="caption">Vous n'avez publié aucun event</Typography>
                                        </Stack>
                                    </caption>
                                ) : (
                                    <TableBody>
                                        {versements.map((contact, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell
                                                    id={contact.id}
                                                >
                                                    <Stack direction={'row'} spacing={1}>
                                                        <Typography variant='subtitle2'>{contact.data().name ? contact.data().name : contact.data().nomEvent}</Typography>
                                                        <CustomTag text={contact.data().status === 0 ? 'Brouillon' : contact.data().status === 1 ? 'Publié' : contact.data().status === 2 ? 'Clos' : null} type={""} tooltipMessage={'cet event es clos'} />
                                                    </Stack>

                                                </TableCell>
                                                <TableCell id={contact.id} >
                                                    <Typography variant='caption'>{format(new Date(handleTimestamp(contact.data().dateDebut)), 'EEE dd, MMMM yyyy', { locale: fr })}</Typography>
                                                </TableCell>
                                                <TableCell id={contact.id} >
                                                    <Typography variant='caption'>{format(new Date(handleTimestamp(contact.data().dateFin)), 'EEE dd, MMMM yyyy', { locale: fr })}</Typography>
                                                </TableCell>
                                                <TableCell id={contact.id}>
                                                    <IconButton key={index} onClick={() => downloadSelectedTicket(index)} sx={{ color: 'red', bgcolor: 'transparent' }}>
                                                        <Iconify icon="material-symbols-light:download" />
                                                        <Typography variant='caption'>Télécharger</Typography>
                                                    </IconButton>
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
                {
                    /** 
                     * <PDFViewer width='100%' height='700' showToolbar>
                    <PdfRedditionDef />
                </PDFViewer>
                     */
                }

            </Container>
        </Page>
    );
}
